/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type WebhookEventType =
  typeof WebhookEventType[keyof typeof WebhookEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebhookEventType = {
  INSTRUCTION_STATE_CHANGED: 'INSTRUCTION_STATE_CHANGED',
  ACCOUNT_CREATED: 'ACCOUNT_CREATED',
  CUSTOMER_STATE_CHANGED: 'CUSTOMER_STATE_CHANGED',
  CUSTOMER_PRODUCT_ACCOUNT_DEPOSIT: 'CUSTOMER_PRODUCT_ACCOUNT_DEPOSIT',
  CUSTOMER_PRODUCT_ACCOUNT_WITHDRAWAL: 'CUSTOMER_PRODUCT_ACCOUNT_WITHDRAWAL',
  INTEREST_RATE_CHANGED: 'INTEREST_RATE_CHANGED',
  CASH_ACCOUNT_TRANSACTION_COMPLETE: 'CASH_ACCOUNT_TRANSACTION_COMPLETE',
  CASH_TRANSACTION: 'CASH_TRANSACTION',
  CASH_ACCOUNT_PAYOUT_FAILED: 'CASH_ACCOUNT_PAYOUT_FAILED',
  INTEREST_REALISED: 'INTEREST_REALISED',
  SAVINGS_TRANSACTION: 'SAVINGS_TRANSACTION',
  CUSTOMER_DOCUMENT_CREATED: 'CUSTOMER_DOCUMENT_CREATED',
  NOMINATED_ACCOUNT_CHANGED: 'NOMINATED_ACCOUNT_CHANGED',
  REJECTED_TRANSACTION: 'REJECTED_TRANSACTION',
  KYC_INFO_REQUIRED: 'KYC_INFO_REQUIRED',
  CUSTOMER_DATA_CHANGED: 'CUSTOMER_DATA_CHANGED',
} as const;
